import { ref } from 'vue'
export const refreshVulnerabilityCallback = ref<Function>()
